// extracted by mini-css-extract-plugin
export default {"noReservationContainer":"NoReservation_noReservationContainer__VEmrC"};